import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../../components/elements/LoadingButton";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import ChooseExpireDate from "../../../components/elements/ChooseExpireDate";
import Alert from "@material-ui/lab/Alert/Alert";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import {currencySymbol} from "../../../../config/values";
import SubTitle from "../../../components/elements/SubTitle";
import SingleImageChooser from "../../fileManager/Components/SingleImageChooser";
import FieldCounterWithoutBar from "../../../components/elements/FieldCounterWithoutBar";
class MakeFestival extends React.Component {

    constructor(props){
        super(props);
        this.ThumbChild = React.createRef();
        this.EditorChild = React.createRef();

    }
    state = {
        fields:{
            name:"",
            type:"",
            value:"",
            ends_at:"",
            ends_at_def:"",
            starts_at:"",
            starts_at_def:"",
            description:"",
        },
        thumbnail: null,
        active:true,
        errors:{},
        loading: false,
        SubmitLoading: false,
        id:this.props.match.params.id,
        editMode:false,
        categories:[],
        defaultCategory:null,
        category_id:null,
        shops:[],
        defaultShop:null,
        shop_id:null,
    };
    classes = this.props.classes;
    async componentDidMount(){
        if(!!this.state.id){
            this.setState({
                editMode:true,
                loading:true,
            })
            await this.loadData();
        }
        await this.loadDefaults();

    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    handleThumbImage(thumbnail){
        this.setState({
            thumbnail: thumbnail
        })
    }
    async loadDefaults(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.get(`${defaultVariabls.url}/parent-categories/quickViewForChooser`, config)
            .then(response => {
                let categories = response.data;
                categories.map((item,index) =>{
                    return item.id === this.state.category_id ? this.setState({
                        defaultCategory: index,
                    }) : null
                })
                this.setState({
                    categories: response.data,
                })
            })
            .catch(error => {
                this.setState({
                    loading:false,
                    SubmitLoading:false
                })
            })
        await axios.get(`${defaultVariabls.url}/shops/quickViewForChooser`, config)
            .then(response => {
                let shops = response.data;
                shops.map((item,index) =>{
                    return item.id === this.state.shop_id ? this.setState({
                        defaultShop: index,
                    }) : null
                })
                this.setState({
                    shops: response.data,
                    loading:false
                })
            })
            .catch(error => {
                this.setState({
                    loading:false,
                    SubmitLoading:false
                })
            })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/festival/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            name: response.data.name,
                            type: response.data.type,
                            value: response.data.value,
                            ends_at: response.data.ends_at,
                            ends_at_def: response.data.ends_at,
                            starts_at: response.data.starts_at,
                            starts_at_def: response.data.starts_at,
                            description: !!response.data.description ? response.data.description : '',
                        },
                        thumbnail: response.data.thumbnail,
                        active: parseInt(response.data.active),
                        category_id: response.data.category_id,
                        shop_id: response.data.shop_id,
                    })

                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(!fields.name){
            formIsValid = false;
            errors['name'] = Translate.emptyField;
        }
        //name
        if(!fields.value){
            formIsValid = false;
            errors['value'] = Translate.emptyField;
        }
        //name
        if(fields.type === "percent"){
            if(fields.value > 100){
                formIsValid = false;
                errors['value'] = Translate.cantBeMoreThan100;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,id,editMode,active,category_id,shop_id,thumbnail} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('type', fields.type);
        data.append('value', fields.value);
        data.append('ends_at', fields.ends_at);
        data.append('starts_at', fields.starts_at);
        data.append('description', fields.description);
        data.append('id', id ? id : 0);
        data.append('category_id', category_id);
        data.append('shop_id', shop_id);
        data.append('active',  active ? 1 : 0);
        data.append('thumbnail', !!thumbnail ? thumbnail.id : 1);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/festival/make`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(editMode ? Translate.dataEdited : Translate.dataAdded, {
                    variant: 'success',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
                if(!this.state.editMode){
                    this.props.history.push(`/manage/festivals`);
                }
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleStartedDate(date){
        let {fields} = this.state;
        fields.starts_at = date;
        this.setState({
            fields
        })
    }
    handleEndedDate(date){
        let {fields} = this.state;
        fields.ends_at = date;
        this.setState({
            fields
        })
    }
    handleChangeActive(){
        this.setState({
            active: !this.state.active,
        })
    }
    handleCategory(value){
        if(value === null){
            this.setState({
                category_id:''
            })
        }else{
            this.setState({
                category_id:value.id
            })
        }
    }
    handleShop(value){
        if(value === null){
            this.setState({
                shop_id:''
            })
        }else{
            this.setState({
                shop_id:value.id
            })
        }
    }
    render(){
        let {fields, errors,SubmitLoading,editMode,active,categories,shops,thumbnail} = this.state;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={editMode ? Translate.editFestival : Translate.makeFestival}>
            {

                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12} md={11} lg={10}>
                                <AppCard
                                    title={editMode ? Translate.editFestival : Translate.makeFestival}
                                    action={
                                        <BreadCrumbs singleLevel firstText={editMode ? Translate.editFestival : Translate.makeFestival}/>
                                    }>
                                    {
                                        this.state.loading ? <AppCardLoaderFields/> :
                                            <Grid container spacing={2} >
                                                <Grid item xs={12}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="name"
                                                        label={Translate.festival_name}
                                                        type="text"
                                                        id="name"
                                                        value={fields.name}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['name']}
                                                        helperText={errors['name']}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} className="expired_at">
                                                    <ChooseExpireDate
                                                        size="medium"
                                                        input={fields.starts_at_def}
                                                        handleDate={this.handleStartedDate.bind(this)}
                                                        label={Translate.festival_starts_at}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} className="expired_at">
                                                    <ChooseExpireDate
                                                        size="medium"
                                                        input={fields.ends_at_def}
                                                        handleDate={this.handleEndedDate.bind(this)}
                                                        label={Translate.festival_ends_at}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="type"
                                                        label={Translate.discount_type}
                                                        type="text"
                                                        value={fields.type}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['type']}
                                                        helperText={errors['type']}
                                                        select
                                                    >
                                                        <MenuItem value="percent">
                                                            {Translate.percent}
                                                        </MenuItem>
                                                        <MenuItem value="fixed">
                                                            {Translate.fixed}
                                                        </MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextField
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        variant="outlined"
                                                        name="value"
                                                        label={Translate.discount_value}
                                                        type="number"
                                                        value={fields.value}
                                                        onChange={this.handleChange.bind(this)}
                                                        error = {!!errors['value']}
                                                        helperText={errors['value']}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    {fields.type === "percent" ? "%" : currencySymbol}
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        variant="outlined"
                                                        margin="normal"
                                                        multiline
                                                        fullWidth
                                                        name="description"
                                                        label={Translate.festivalDescription}
                                                        placeholder={Translate.festivalDescriptionDesc}
                                                        type="text"
                                                        id="description"
                                                        minRows="4"
                                                        value={fields.description}
                                                        onChange={this.handleChange.bind(this)}
                                                        error={!!errors['description']}
                                                        helperText={errors['description']}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <FieldCounterWithoutBar length={fields.description.length} max={600}/>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={4} lg={3}>
                                                    <SubTitle>{Translate.festivalBanner}</SubTitle>
                                                    <SingleImageChooser
                                                        primary
                                                        onChange={(thumbnail) => this.handleThumbImage(thumbnail)}
                                                        initial={thumbnail}
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Alert
                                                        severity="info"
                                                        action={
                                                            <FormControlLabel
                                                                style={{marginRight:10}}
                                                                control={
                                                                    <Switch
                                                                        checked={active}
                                                                        onChange={this.handleChangeActive.bind(this)}
                                                                        value={active}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={active ? Translate.active : Translate.inactive}
                                                            />
                                                        }
                                                    >
                                                        {Translate.activityStatus}
                                                    </Alert>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <LoadingButton
                                                        variant="contained"
                                                        color="primary"
                                                        onClick = {this.handleSubmit.bind(this)}
                                                        loading = {SubmitLoading}
                                                    >
                                                        {editMode ? Translate.editFestival : Translate.makeFestival}
                                                    </LoadingButton>
                                                </Grid>
                                            </Grid>
                                    }
                                </AppCard>
                            </Grid>
                        </Grid>
                }
            </AppAnimate>

        );
    }
}

export default withSnackbar(withRouter(withStyles(Styles)(MakeFestival)));